import debug from 'debug';
import velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.js';

const log = debug('VelocityAnimate');

export class VelocityTransitions {
	
	constructor() {

		this.velocity = velocity;

		velocity.RegisterEffect('ShrinkIn', {
			defaultDuration: 750,
			calls: [
				[{
					opacity: [ 1, 0 ],
					transformOriginX: [ "50%", "50%" ],
					transformOriginY: [ "50%", "50%" ],
					scaleX: [ 1, 1.5 ],
					scaleY: [ 1, 1.5 ],
					translateZ: 0
				}]
			]
		});

		velocity.RegisterEffect('ShrinkOut', {
			defaultDuration: 600,
			calls: [
				[{
					opacity: [ 0, 1 ],
					transformOriginX: [ "50%", "50%" ],
					transformOriginY: [ "50%", "50%" ],
					scaleX: 1.3,
					scaleY: 1.3,
					translateZ: 0
				}]
			],
			reset: {
				scaleX: 1,
				scaleY: 1
			}
		});
	}
}

export let velocityTransitions = new VelocityTransitions();

